import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("widgetsReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	widgets: {}
});

function widgetsReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset widgets state");
			return initialState;
		}
		case actionTypes.UPDATE_WIDGET_STATUS: {
			const {widgets} = state;

			widgets[action.name] = {
				ts: new Date().valueOf(),
				status: action.status,
				data: action.data
			};

			return {
				...state,
				widgets
			};
		}
		default:
			return state;
	}
}

export default widgetsReducer;
